import { LOCALE_ID, Provider } from '@angular/core';
import { I18nService } from './i18n.service';

/** the Angular locale of a site language: the formatting pipes and the captcha language read it */
export function localeIdFor(langIsHeb: boolean): string {
    return langIsHeb ? 'he-IL' : 'en-US';
}

/**
 * LOCALE_ID per site, not a constant: the english bundle carries no hebrew locale data
 * (the cli injects data for the built locale only), so a hard-wired he-IL made every
 * number/date pipe on the english site throw NG02100 "missing locale data".
 */
export const LOCALE_ID_PROVIDER: Provider = {
    provide: LOCALE_ID,
    useFactory: (i18n: I18nService) => localeIdFor(i18n.langIsHeb()),
    deps: [I18nService],
};
